import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";

import { errorCallback } from "./error";

import { GetTags, GetTagById, DeleteTag } from "@/api/services/tag";
import { FilterBody } from "@/api/types";

export function useTags(params: FilterBody) {
    return useQuery({ queryKey: ["tags", params], queryFn: () => GetTags(params) });
}

export function useTagByID(id: number) {
    return useQuery({ queryKey: ["tag", id], queryFn: () => GetTagById(id), enabled: !!id });
}

export function useDeleteTag() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    return useMutation({
        mutationFn: (id: number) => DeleteTag(id),
        onError: errorCallback,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["Genres"] });
            enqueueSnackbar("The Genre Deleted Successfully", { variant: "success" });
        },
    });
}
